import React, { useState, useEffect } from 'react'
import { Modal, Form, Radio, Input, Spin, App, Space } from 'antd';
import Icon from '../../cpn/Icon';
import { useKPSQbohuiMutation, useKPSQupdatecontentMutation } from '../../store/DianShangYeWuApi';

function InvoiceNodeCheckEdit(props) {
    const {message} = App.useApp();
    const [open, setOpen] = useState(false);
    const [form] = Form.useForm();
    const [updateIsFetching, setUpdateIsFetching] = useState(false);
    const [bohui] = useKPSQbohuiMutation();
    const [updateContent] = useKPSQupdatecontentMutation();
    useEffect(() => {              
        form.setFieldsValue({
            kpsq_sp_state: props.kpsq_sp_state ==='4'?'4':'3',
            kpsq_sp_content: props.kpsq_sp_content,
        });
    }, [
        props.kpsq_sp_id, 
        props.kpsq_sp_jd_xuhao, 
        props.kpsq_sp_jd_name, 
        props.kpsq_sp_yh_id, 
        props.kpsq_sp_yh_name, 
        props.kpsq_sp_uid, 
        props.kpsq_sp_uname, 
        props.kpsq_sp_state, 
        props.kpsq_sp_content, 
        props.sortedData,
        props.kpsq_sp_state_time,
        form
    ]);
    return (
        <>
            <Space orientation='vertical' size={1}>
                <span style={{color:props.kpsq_sp_state==='4' ? 'red' : 'green',fontWeight:"bold"}}>
                    {props.kpsq_sp_state==='4' ? '已驳回' : '已同意'}
                    {props.kpsq_sp_content? '：'+props.kpsq_sp_content :''}
                </span>
                <span>{props.yh_name} {props.kpsq_sp_state_time} </span>
                <Icon type="edit"  onClick={() => {setOpen(true);}} title='修改审批说明'/>
            </Space>
            <Modal 
                open={open} 
                onCancel={() => {
                    setOpen(false);
                    setUpdateIsFetching(false);
                }} 
                footer={null}
                title='审批开票申请'
            >
                <Spin spinning={updateIsFetching} tip="审批中...">
                    <Form
                        form={form}
                        name={`form_kpsq_sp_${props.kpsq_sp_id}`}
                        initialValues={{kpsq_sp_content: '',}}
                        labelCol={{ span: 5}}
                        wrapperCol={{ span: 19 }}
                        onFinish={(value) => {
                            if((value.kpsq_sp_state === '3' && props.kpsq_sp_state === '3') || (value.kpsq_sp_state === '4' && props.kpsq_sp_state === '4') || (value.kpsq_sp_state === '3' && props.kpsq_sp_state==='5')){
                                updateContent({
                                    'kpsq_sp_id': props.kpsq_sp_id,
                                    'kpsq_sp_content': value.kpsq_sp_content,
                                    'kpsq_sp_yh_id': props.kpsq_sp_yh_id,
                                    'kpsq_sp_yh_name': props.kpsq_sp_yh_name
                                }).then((res) => {
                                    if(res.data.Status === 'success'){
                                        message.success('审批说明修改成功');
                                        setUpdateIsFetching(false);
                                        setOpen(false);
                                    }else{
                                        message.error('审批说明修改失败'+res.data.Message);
                                        setUpdateIsFetching(false);
                                        setOpen(false);
                                    }
                                });
                                return;                            
                            }else if(value.kpsq_sp_state === '4' &&  props.kpsq_sp_state === '3'){
                                bohui({
                                    'kpsq_sp_id': props.kpsq_sp_id,
                                    'kpsq_id': props.kpsq_id,
                                    'kpsq_sp_yh_id': props.kpsq_sp_yh_id,
                                    'kpsq_sp_content': value.kpsq_sp_content
                                }).then((res) => {
                                    if(res.data.Status === 'success'){
                                        message.success('驳回成功');
                                        setUpdateIsFetching(false);
                                        setOpen(false);
                                    }else{
                                        message.error('驳回失败'+res.data.Message);
                                        setUpdateIsFetching(false);
                                        setOpen(false);
                                    }
                                });
                            }else{
                                console.log(props.kpsq_sp_state, value.kpsq_sp_state);
                                
                                if(props.kpsq_sp_state === '5' && value.kpsq_sp_state === '4'){
                                    message.error('已结束的单据不能驳回！')
                                }else if(props.kpsq_sp_state === '4' && value.kpsq_sp_state === '3'){
                                    message.error('已驳回的单据不能同意审批！')
                                }
                                setUpdateIsFetching(false);
                            }
                         
                        }}
                    >                    
                    <Form.Item name="kpsq_sp_state" label="审批意见">
                        <Radio.Group disabled>
                            <Radio value="3">同意</Radio>
                            <Radio value="4">驳回</Radio>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item name="kpsq_sp_content" label="说明">
                        <Input.TextArea rows={4} />
                    </Form.Item>
                    <Form.Item wrapperCol={{ offset: 5, span: 19 }}>
                        <Icon type="save"  onClick={() => {
                            // 弹出加载中Spin
                            setUpdateIsFetching(true);
                            form.submit();
                        }}/>
                    </Form.Item>
                </Form>
                </Spin>
            </Modal>
        </>
    )
}

export default InvoiceNodeCheckEdit